import store from "../store/Store";
import { startProcess, stopProcess } from "../store/slices/ApplicationSlice";
import {
  createClinicianEndpoint,
  updateClinicianEndpoint,
  completeOnboardingEndpoint,
} from "./api/Clinician";

export const createClinician = async clinicianData => {
  try {
    store.dispatch(startProcess("Creating clinician profile"));
    const response = await createClinicianEndpoint(clinicianData);
    store.dispatch(stopProcess());
    return response;
  } catch (error) {
    store.dispatch(stopProcess());
    throw new Error(`Error creating clinician profile: ${error.message}`);
  }
};

export const updateClinician = async (updatedClinicianData, clinicianId) => {
  try {
    store.dispatch(startProcess("Updating clinician profile"));
    const response = await updateClinicianEndpoint(
      updatedClinicianData,
      clinicianId
    );
    store.dispatch(stopProcess());
    return response;
  } catch (error) {
    store.dispatch(stopProcess());
    throw new Error(`Error updating clinician: ${error.message}`);
  }
};

export const completeOnboarding = async clinicianId => {
  try {
    store.dispatch(startProcess("Completing onboarding"));
    const response = await completeOnboardingEndpoint(clinicianId);
    store.dispatch(stopProcess());
    return response;
  } catch (error) {
    store.dispatch(stopProcess());
    throw new Error(`Error completing onboarding: ${error.message}`);
  }
};
